"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanonicalRoundingRule = exports.CanonicalPriceEntry = exports.CanonicalPriceListSummary = exports.MoneyMinor = exports.TaxRoundingStrategy = exports.RoundingMode = exports.PriceListStatus = exports.CurrencyCode = void 0;
const zod_1 = require("zod");
/**
 * Canonical pricing representation for cross-cutting consumers (CSV importer,
 * future REST adapters, sync protocol).
 *
 * Money is integer smallest-unit (cents for EUR, kopecks for UAH). Values
 * are serialised as strings on the wire to survive JSON 53-bit limits;
 * services parse to BigInt internally. (TRS §19.1.)
 */
exports.CurrencyCode = zod_1.z.string().regex(/^[A-Z]{3}$/, 'ISO-4217 alpha-3');
exports.PriceListStatus = zod_1.z.enum(['active', 'archived']);
exports.RoundingMode = zod_1.z.enum(['banker', 'half_up', 'half_down', 'floor', 'ceil']);
exports.TaxRoundingStrategy = zod_1.z.enum([
    'per_line_inclusive',
    'per_line_exclusive',
    'basket_level',
]);
/** A bigint serialised as a base-10 string (avoids JSON 53-bit precision loss). */
exports.MoneyMinor = zod_1.z.string().regex(/^-?\d+$/, 'integer minor units as a base-10 string');
exports.CanonicalPriceListSummary = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().max(1024).optional(),
    currencyCode: exports.CurrencyCode,
    isDefault: zod_1.z.boolean().default(false),
    status: exports.PriceListStatus.default('active'),
});
exports.CanonicalPriceEntry = zod_1.z.object({
    /** Either itemId (existing) or itemSku (resolve at commit time). */
    itemId: zod_1.z.string().optional(),
    itemSku: zod_1.z.string().optional(),
    unitPriceMinor: exports.MoneyMinor,
    costMinor: exports.MoneyMinor.optional(),
});
exports.CanonicalRoundingRule = zod_1.z.object({
    currencyCode: exports.CurrencyCode,
    decimalPlaces: zod_1.z.number().int().min(0).max(4).default(2),
    lineRoundingMode: exports.RoundingMode.default('banker'),
    cashRoundingIncrementMinor: exports.MoneyMinor.nullable().optional(),
    taxRoundingStrategy: exports.TaxRoundingStrategy.default('per_line_inclusive'),
});
//# sourceMappingURL=pricing.js.map